import { render, staticRenderFns } from "./DashboardSoftwareDev.vue?vue&type=template&id=6925fdb2&scoped=true"
import script from "./DashboardSoftwareDev.vue?vue&type=script&lang=js"
export * from "./DashboardSoftwareDev.vue?vue&type=script&lang=js"
import style0 from "./DashboardSoftwareDev.vue?vue&type=style&index=0&id=6925fdb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6925fdb2",
  null
  
)

export default component.exports